import { observer } from "mobx-react-lite";
import Investments from "../../components/financier/investments/Investments";
import FinancierSharedView from "../shared/FinancierSharedView";

export default observer(function FinancierInvestments() {
  return <FinancierSharedView mainContent={<Investments />} />;
});
